import React from 'react';
import PropTypes from 'prop-types';

import * as Misc from '../../misc';
import ProjectScope from '../projectScope/projectScope';
import Analytics from './../../analytics';
import StonesStore from '../../stores/stonesStore';

export default class QuoteSummaryItem extends React.Component {
  static propTypes = {
    deleteLastQuoteClick: PropTypes.func,
    quote: PropTypes.object,
    router: PropTypes.object
  };

  handleClick = (e) => {
    Analytics.sendClickEvent('summary-select-quote');
    Misc.ignoreDefault(e);
    ProjectScope.setCurrentQuote(this.props.quote.uid);
  };

  handleDeleteClick = (e) => {
    Analytics.sendClickEvent('summary-quote-delete');
    Misc.ignoreDefault(e);
    if (ProjectScope.quotesCount() > 1) {
      ProjectScope.deleteQuote(this.props.quote.uid);
    } else {
      this.props.deleteLastQuoteClick();
    }
  };

  handleEditQuoteClick = (e) => {
    Analytics.sendClickEvent('summary-edit-quote');
    Misc.ignoreDefault(e);
    ProjectScope.setCurrentQuote(this.props.quote.uid);
    this.props.router.push('/scope');
  };

  handleGoToStones = () => {
    Analytics.sendClickEvent('summary-edit-quote');
    if (ProjectScope.quoteSubmitted) {
      return;
    }
    this.props.router.push('/stones');
  };

  render() {
    const {quote} = this.props;
    const isSelected = quote.uid === ProjectScope.quote().uid;
    let style = {};
    let content = null;
    if (quote.stone) {
      let fullImageUrl = quote.stone.ImageFullUrl
        , imageUrl = quote.stone.ImageUrl;

      if (quote.stone.StoneSupplierStones[0].ImageKey && quote.stone.StoneSupplierStones[0].ImageKey.length > 0) {
        fullImageUrl = "https://s3.amazonaws.com/stone_images/sss-" + quote.stone.StoneSupplierStones[0].ImageKey;
        imageUrl = "https://s3.amazonaws.com/stone_images/sss-thumbnail-" + quote.stone.StoneSupplierStones[0].ImageKey;
      }
      const bgUrl = imageUrl || fullImageUrl;
      if (bgUrl) {
        style = {
          backgroundImage: "url('" + bgUrl + "')"
        };
      }
      content = (<div className="review-submit-stone-listitemrenderer-text">
        <h10>${quote.totalPrice.toFixed(2)}</h10>
      </div>);
    } else {
      content = (
        <div className="review-submit-stone-button-wrapper">
          <div className="review-submit-stone-button" onClick={this.handleEditQuoteClick}>
            <div className="review-submit-stone-button-icon"/>
            Edit Quote
          </div>
        </div>
      );
    }

    const navbuttons = (
      <div className="review-submit-stone-buttons-wrapper">
        <div className="review-submit-edit-button" onClick={this.handleGoToStones}>Edit</div>
        <div className="review-submit-stone-listitemrenderer-remove-button" onClick={this.handleDeleteClick}/>
      </div>
    );

    let stoneName = (quote.stone && quote.stone.Name);
    const _sss = quote.stone && quote.stone.StoneSupplierStones[0];
    if (_sss && _sss.CustomStoneName && $.trim(_sss.CustomStoneName).length > 0) {
      stoneName = _sss.CustomStoneName;
    }

    return (
      <div
        className={"review-submit-stone-lir-wrapper " + (isSelected ? 'review-submit-stone-lir-wrapper--selected' : '')}>
        <div className="review-submit-stone-lir-wrapper-image">
          <div className="review-submit-stone-listitemrenderer" style={style} onClick={this.handleClick}>
            {isSelected ? navbuttons : null}
            {content}
          </div>
        </div>
        <div className="review-submit-stone-title">{stoneName}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projectSummary/quoteSummaryItem.js